import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Package2, ArrowLeft } from 'lucide-react';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success('If an account exists, a reset email has been sent.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-secondary/30 to-background p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary text-primary-foreground mb-4">
            <Package2 className="w-8 h-8" />
          </div>
          <h1 className="text-2xl font-bold font-[Manrope] text-foreground tracking-tight">Forgot password</h1>
          <p className="text-muted-foreground mt-2">Reset link will be emailed to you.</p>
        </div>
        <Card className="border-border/60">
          <CardHeader>
            <CardTitle className="font-[Manrope]">Reset your password</CardTitle>
          </CardHeader>
          <CardContent>
            {sent ? (
              <div className="text-sm text-muted-foreground space-y-4">
                <p>If an account with <b>{email}</b> exists, we've sent a password-reset link. The link is valid for 1 hour.</p>
                <Link to="/login" className="inline-flex items-center text-primary hover:underline text-sm"><ArrowLeft className="w-4 h-4 mr-1"/> Back to sign in</Link>
              </div>
            ) : (
              <form onSubmit={onSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" />
                </div>
                <Button type="submit" className="w-full" disabled={loading}>
                  {loading ? 'Sending…' : 'Send reset link'}
                </Button>
                <Link to="/login" className="block text-center text-xs text-muted-foreground hover:text-primary">Back to sign in</Link>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
